import './style.sass';

import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const list = [
    'Ссылочное продвижение основных конверсионных страниц,',
    ' Проработка текущих страниц с целью повышения позиций сайта в поисковой выдаче,',
    'Работа с информационным спросом по основным и побочным продуктам проекта,',
    'Создание новых страниц на сайте.',
];

const UkassaJob = () => {
    return (
        <ScrollAnimation delay={0} animateIn="fadeIn" offset={300} animateOnce={true} duration={1}>
            <div className="ukassa-job">
                <FullWrapper bigPaddings isMargin={false}>
                    <div className="ukassa-job__content">
                        <span className="ukassa-job__title">
                            Мы сформировали новую стратегию с ключевыми точками развития на полгода,
                            в нее вошли:
                        </span>
                        <div className="ukassa-job__list">
                            {list.map((text, index) => {
                                return (
                                    <div key={index} className="ukassa-job__item">
                                        <span className="ukassa-job__number">{index + 1}.</span>
                                        <span className="ukassa-job__text">{text}</span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </FullWrapper>
            </div>
        </ScrollAnimation>
    );
};

export default UkassaJob;
